/**
 * Generic object pool — avoids allocations during a fight.
 * Used for: bullets, particles, gems, damage numbers.
 */
export class Pool<T> {
  private free: T[] = [];

  constructor(
    private readonly create: () => T,
    prealloc = 0,
  ) {
    for (let i = 0; i < prealloc; i++) this.free.push(create());
  }

  acquire(): T {
    return this.free.pop() ?? this.create();
  }

  release(item: T): void {
    this.free.push(item);
  }

  get available(): number {
    return this.free.length;
  }
}
